export enum MetadataFieldBaseTypeEnum {
  String = "String",
  Long = "Long",
  Boolean = "Boolean",
  DateTime = "DateTime",
  AssetAnyTitle = "AssetAnyTitle",
  MetadataFieldReference = "MetadataFieldReference",
  Integer = "Integer",
}
